import dayjs from 'dayjs'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import {
  getLocalContactTimeFormatted,
  getNextQuietHoursSendAt,
  getQuietHoursAvailableTime,
} from 'entities/QuietHours/lib/quietHours'

const QUIET_HOURS_CALL_MODAL_ID = 'quiet_hours_call_modal'

export type IShowCallDuringQuietHoursModalParams = {
  timezone: string
  contactName: string
  quietHoursAllowedTimeFrom: string
  quietHoursAllowedTimeTo: string
  isQuietHoursBlockOnWeekend: boolean
  onConfirm: () => void | Promise<void>
  onCancel?: () => void
}

export const CallDuringQuietHoursModal = ({
  timezone,
  contactName,
  quietHoursAllowedTimeFrom,
  quietHoursAllowedTimeTo,
  isQuietHoursBlockOnWeekend,
  onConfirm,
  onCancel,
}: IShowCallDuringQuietHoursModalParams) => {
  const localContactTime = getLocalContactTimeFormatted(timezone)

  const sendAt =
    getNextQuietHoursSendAt({
      contactTZ: timezone,
      allowed_time_from: quietHoursAllowedTimeFrom,
      allowed_time_to: quietHoursAllowedTimeTo,
      is_block_on_weekend: isQuietHoursBlockOnWeekend,
    }) ?? dayjs().tz(timezone).add(1, 'hour').startOf('hour')
  const availableTimeText = getQuietHoursAvailableTime({ tz: timezone, send_at: sendAt })

  const handleConfirm = async () => {
    modalStore.removeModal(QUIET_HOURS_CALL_MODAL_ID)
    await onConfirm()
  }

  const handleCancel = () => {
    modalStore.removeModal(QUIET_HOURS_CALL_MODAL_ID)
    onCancel?.()
  }

  modalStore.addModal({
    disabledOnAllClose: true,
    type: ModalTypeList.WARNING,
    title: 'Call during quiet hours?',
    id: QUIET_HOURS_CALL_MODAL_ID,
    desc: (
      <>
        It’s currently {localContactTime} for {contactName}.<br /> We recommend waiting until quiet
        hours end ({availableTimeText}) before placing a call.
      </>
    ),
    primaryAction: {
      text: 'Yes, call anyway',
      onAction: handleConfirm,
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: handleCancel,
    },
  })
}
